module.exports = __webpack_public_path__ + "img/kjsy_detail.cc64ce25.jpg";